<template>
  <div
    class="custom-select-color-dropdown-content"
  >
    <div
      class="custom-select-color-dropdown-content__option"
      :key="option.value"
      v-for="option in options"
      @click="toggle(option)"
    >
      <color-select-option
        class="custom-select-color-dropdown-content__color"
        :color="option.hex"
        :is-selected="isSelected(option)"
      />
      <div class="custom-select-color-dropdown-content__label">
        {{ option.label }}
      </div>
    </div>
  </div>
</template>

<script>
import ColorSelectOption from '@kit/color-select-option/color-select-option.vue';

export default {
  components: {
    ColorSelectOption,
  },

  props: {
    options: {
      type: Array,
      default: () => []
    },
    selectedOptions: {
      type: Array,
      default: () => []
    },
  },

  methods: {
    isSelected(option) {
      return this.selectedOptions.some(({ value }) => value === option.value);
    },
    toggle(option) {
      const event = this.isSelected(option)? 'remove' : 'add';

      this.$emit(event, option);
    },
  },
}
</script>

<style lang="scss">
  .custom-select-color-dropdown-content {
    width: 240px;
    padding: 8px 0;

    &__option {
      cursor: pointer;
      font-size: 14px;
      transition: $transitionDuration backgroun-color ease;
      padding: 8px 0;

      &:hover {
        background-color: $gray_bgr;
      }
    }

    &__label {
      display: inline-block;
      vertical-align: middle;
    }

    &__color {
      display: inline-block;
      vertical-align: middle;
      margin-right: 8px;
      margin-left: 16px;
    }
  }
</style>